export default __webpack_public_path__ + "static/media/location.04b50bdd.svg";